export const fuzzySearch = (array: any[], keys: string[], searchTerm: string) => {
  searchTerm = searchTerm.toLowerCase();
  return array
    .map(arrayItem => {
      let points = 0;
      const valueWords = searchTerm.split(' ');
      keys.forEach(key => {
        const value = arrayItem[key] || '';
        valueWords.forEach(valueWord => {
          const words = value.toLowerCase().split(' ');
          const wordIndex = words.findIndex(w => w.includes(valueWord));
          if (wordIndex > -1) {
            const titleWord = words[wordIndex];
            const valueIndex = titleWord.indexOf(valueWord);
            // Giving more points if the word is earlier
            points += (1 - wordIndex / words.length) * valueIndex === 0 ? 2 : 1;
          }
        });
        if (value === searchTerm) points += 100;
      });

      return { item: arrayItem, points };
    })
    .filter(d => d.points)
    .sort((a, b) => b.points - a.points)
    .map(d => d.item);
};
